import ctaImg1 from 'website/assets/viktor-bystrov.png'
import ctaImg2 from 'website/assets/happy-young-couple-enjoying-their-brand-new-car.png'

const assets: Record<string, string> = {
  ctaImg1,
  ctaImg2
}

export default assets
